import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const PLANS = [
  { id: "free", name: "Gratuit", price: "0 €", features: ["Fiche issue du répertoire SIRENE", "Revendication avec votre SIRET", "Téléphone et email affichés", "Réponse aux avis clients"] },
  { id: "essentiel", name: "Essentiel", price: "4,90 €", features: ["Tout le gratuit", "Présentation de l'entreprise", "Site web et horaires", "Marques représentées", "Compétences et spécialités"] },
  { id: "pro", name: "Pro", price: "9,90 €", highlight: true, features: ["Tout l'Essentiel", "Catalogue produits avec stock", "Galerie photos (30 photos)", "Mise en avant à note égale", "Badge Pro sur la carte"] },
];

const FAQ = [
  ["Ma fiche existe-t-elle déjà ?", "Oui, très probablement : toutes les entreprises actives du répertoire officiel SIRENE sont consultables. Cherchez votre nom ou entrez votre SIRET dans votre espace."],
  ["Comment revendiquer ma fiche ?", "Créez un compte puis saisissez votre numéro SIRET à 14 chiffres dans « Mon espace ». La revendication est gratuite."],
  ["Puis-je résilier à tout moment ?", "Oui. L'abonnement est mensuel et sans engagement : vous gardez les avantages jusqu'à la fin de la période payée."],
  ["Puis-je supprimer un avis négatif ?", "Non, mais vous pouvez y répondre publiquement. Les avis abusifs peuvent être signalés à l'administrateur."],
];

export default function Pricing() {
  return (
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8" data-testid="pricing-page">
      <p className="text-xs font-bold uppercase tracking-wider text-[#1E40AF]">Professionnels</p>
      <h1 className="mt-3 max-w-2xl font-display text-4xl font-extrabold tracking-tight sm:text-5xl">Soyez trouvé pour ce que vous faites vraiment.</h1>
      <p className="mt-4 max-w-xl text-slate-600">Abonnement mensuel, sans engagement.</p>
      <div className="mt-12 grid gap-6 md:grid-cols-3">
        {PLANS.map((p) => (
          <div key={p.id} className={`flex flex-col rounded-2xl border p-7 ${p.highlight ? "border-slate-900 bg-slate-900 text-white shadow-2xl" : "border-slate-200 bg-white"}`} data-testid={`plan-card-${p.id}`}>
            <h3 className="font-display text-xl font-bold">{p.name}</h3>
            <p className="mt-4"><span className="font-display text-5xl font-extrabold">{p.price}</span><span className={p.highlight ? "text-slate-400" : "text-slate-500"}> /mois</span></p>
            <ul className="mt-6 flex-1 space-y-3 text-sm">
              {p.features.map((f) => <li key={f} className="flex gap-2"><Check className={`h-4 w-4 shrink-0 ${p.highlight ? "text-[#60A5FA]" : "text-[#166534]"}`} />{f}</li>)}
            </ul>
            <Link to="/mon-espace" className={`mt-8 rounded-full py-3 text-center text-sm font-semibold transition-colors ${p.highlight ? "bg-white text-slate-900 hover:bg-[#D97706] hover:text-white" : "bg-slate-900 text-white hover:bg-[#1E40AF] hover:text-white"}`} data-testid={`plan-cta-${p.id}`}>
              {p.id === "free" ? "Revendiquer ma fiche" : `Choisir ${p.name}`}
            </Link>
          </div>
        ))}
      </div>
      <div className="mt-20 max-w-3xl">
        <h2 className="font-display text-2xl font-bold">Questions fréquentes</h2>
        <Accordion type="single" collapsible className="mt-6" data-testid="pricing-faq">
          {FAQ.map(([q, a], i) => (
            <AccordionItem key={q} value={`f${i}`}>
              <AccordionTrigger className="text-left font-semibold" data-testid={`faq-trigger-${i}`}>{q}</AccordionTrigger>
              <AccordionContent className="text-slate-600">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
